var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 29,
    viewBox: "0 0 17 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5432 0.447741C15.9341 -0.149247 14.9465 -0.149247 14.3374 0.447741L2.20576 12.3381L2.20574 12.3381L-1.58926e-05 14.5L-6.33815e-07 14.5L2.20576 16.6619L14.3374 28.5522C14.9465 29.1492 15.9341 29.1492 16.5432 28.5522C17.1523 27.9552 17.1523 26.9873 16.5432 26.3903L4.41152 14.5L16.5432 2.60963C17.1523 2.01264 17.1523 1.04473 16.5432 0.447741Z",
    fill: "#FF1616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.675ab1f120d7b9941f5f06a41a49390f.svg";
export { ForwardRef as ReactComponent };